import React, { useState, useEffect, useRef } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { useAuth } from '../pages/authContext';
import { firebaseConfig } from '../pages/firebase';

import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from '../pages/NewPatientModal.jsx.jsx';
import { Button, Modal } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import { doSignOut } from '../pages/auth.js';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";

import ProfileComponent from '../pages/ProfileComponent.jsx';
import { BorderRight, CreditCard } from '@mui/icons-material';
import StateModal from '../pages/StateModal.jsx';
import TenantModal from '../pages/TenantModal.jsx';
// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Static chatrooms and emojis
const chatrooms = ['announcements', 'general', 'wins', 'brrrr'];
const chatroomEmojis = { announcements: '📢', general: '💬', wins: '🏆', brrrr: '❄️' };
const reactionEmojis = ['↩️','🚨','😂','💪','👍','❗️','🔥','💯','😎','👀','🍴'];

// Inline styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row-reverse', // sidebar on right
    flex: 1,
    minWidth: 0,
transform: 'translateX(-.8px)',
    height: '100vh',
    backgroundColor: '#202225',
    margin: 0,
    padding: 0,
    fontFamily: 'Arial, sans-serif',
    // no transform needed any more
  },
  mention: {
    color: '#3399FF',
    fontWeight: 'bold',
  },
  link: {
    color: '#4EA1FF',
    textDecoration: 'underline',
  },

  sidebar: {
    width: '240px',
    backgroundColor: '#2f3136',
    color: '#fff',
    padding: '16px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    borderLeft: '1px solid #202225',   // fills left edge gap
  },
  sidebarHeader: { margin:0, fontSize:'1.2rem', color:'#7289da' },
  channelList: { listStyle:'none', padding:0, margin:'16px 0 0' },
  channelItem: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px', cursor:'pointer', borderRadius:'4px' },
  activeChannel: { backgroundColor:'#40444b' },
  badge: { backgroundColor:'#f04747', borderRadius:'12px', padding:'2px 6px', fontSize:'0.75rem', color:'#fff' },
  chatArea: { flex:1, position:'relative',     minWidth: 0,        borderRight: '1px solid #202225',  // fills right edge gap
       // ← prevent shrinking to content width
display:'flex', flexDirection:'column' },
  chatHeader: { padding:'12px 16px', backgroundColor:'#2f3136', borderBottom:'1px solid #202225', color:'#fff' },
  messages: { flex:1, padding:'16px',     minWidth: 0,           // ← prevent shrinking to content width
overflowY:'auto', backgroundColor:'#202225', paddingBottom:'80px' },
  messageItem: { display:'flex', marginBottom:'12px', position:'relative', borderRadius:'4px' },
  highlightedMessage: { backgroundColor:'#2f3136' },
  replyInline: { backgroundColor:'#2f3136', color:'#fff', padding:'4px 8px', borderLeft:'3px solid #5865F2', marginBottom:'4px', borderRadius:'4px', fontSize:'0.85rem' },
  avatar: { width:'32px', height:'32px', borderRadius:'50%', marginRight:'12px' },
  meta: { fontSize:'0.75rem', marginBottom:'4px', color:'#b9bbbe', display:'flex', alignItems:'center', gap:'8px' },
  sender: { color:'#5865F2', fontSize:'0.9rem', fontWeight:'bold' },
  text: { color:'#dcddde', margin:0, fontSize:'0.85rem' },
  reactionsContainer: { display:'flex', gap:'4px', marginTop:'4px' },
  reaction: { display:'flex', alignItems:'center', backgroundColor:'#40444b', borderRadius:'12px', padding:'2px 6px', color:'#fff', fontSize:'0.9rem' },
  reactionEmoji: { marginRight:'4px' },
  reactionCount: { marginLeft:'4px', fontSize:'0.75rem', color:'#fff' },
  inputWrapper: { position:'absolute', bottom:'16px', left:'16px', right:'16px', display:'flex', alignItems:'center', padding:'8px 16px', backgroundColor:'#2f3136', borderRadius:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.4)' },
  input: { flex:1, padding:'8px 12px', border:'none', backgroundColor:'transparent', color:'#fff', fontSize:'1rem', outline:'none', borderRadius:'20px' },
  emojiButton: { background:'none', border:'none', color:'#fff', cursor:'pointer', fontSize:'1.2rem' },
  emojiPicker: { position:'absolute', bottom:'56px', left:'16px', backgroundColor:'#2f3136', padding:'8px', borderRadius:'8px', display:'flex', gap:'8px' },
  mentionList: { position:'absolute', bottom:'65px', left:'16px', backgroundColor:'#2f3136', borderRadius:'4px', maxHeight:'150px', overflowY:'auto', width:'200px', padding:'4px', boxShadow:'0 2px 8px rgba(0,0,0,0.4)' },
  mentionItem: { padding:'4px', cursor:'pointer', color:'#fff', fontSize:'0.85rem' },
  replyPreview: { position:'absolute', bottom:'96px', left:'16px', right:'16px', backgroundColor:'#2f3136', padding:'8px', borderRadius:'8px', display:'flex', justifyContent:'space-between', alignItems:'center', color:'#fff' }
};

export default function Community() {
  const { currentUser } = useAuth();
  const [selectedChannel, setSelectedChannel] = useState('general');
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState('');
  const [hoveredMsg, setHoveredMsg] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showMention, setShowMention] = useState(false);
  const [mentionResults, setMentionResults] = useState([]);
  const [unread, setUnread] = useState({});
  const [lastRead, setLastRead] = useState(null);
  const [replyToMessage, setReplyToMessage] = useState(null);
  const inputRef = useRef();
  const messagesEndRef = useRef();
  const [loggedInUser, setLoggedInUser] = useState(null);
    const [user, setUser] = useState(null);
const suggestionList = [
  ...mentionResults,
  { name: 'all' },
  { name: 'everyone' }
];

function renderTextWithMentions(text, styles) {
  // Split out any “@…” sequence, including a standalone “@”
  const parts = text.split(/(@\S*)/g);
  return parts.map((part, i) =>
    part.startsWith('@') ? (
      <span key={i} style={styles.mention}>{part}</span>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}
useEffect(() => {
  if (!currentUser) return;
  const unsub = firebase
    .firestore()
    .collection('users')
    .doc(currentUser.uid)
    .onSnapshot(doc => {
      if (doc.exists) setLoggedInUser(doc.data());
    });
  return () => unsub();
}, [currentUser]);
  
  // Hide mentions when input clears
  useEffect(() => {
    if (newMsg === '') {
      setShowMention(false);
    }
  }, [newMsg]);

  // Load lastRead timestamp
  useEffect(() => {
    if (!currentUser) return;
    return firebase.firestore().collection('users').doc(currentUser.uid)
      .onSnapshot(doc => setLastRead(doc.data()?.communityChatsLastRead?.toDate()));
  }, [currentUser]);

  // Unread counts
  useEffect(() => {
    if (!lastRead) return;
    chatrooms.forEach(room => {
      firebase.firestore().collection(room)
        .where('createdAt', '>', firebase.firestore.Timestamp.fromDate(lastRead))
        .onSnapshot(snap => setUnread(u => ({ ...u, [room]: snap.size })));
    });
  }, [lastRead]);

  // Subscribe to messages
  useEffect(() => {
    const unsub = firebase.firestore().collection(selectedChannel)
      .orderBy('createdAt')
      .onSnapshot(snap => {
        setMessages(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        // update lastRead
        firebase.firestore().collection('users').doc(currentUser.uid).update({ communityChatsLastRead: firebase.firestore.FieldValue.serverTimestamp() });
      });
    return () => unsub();
  }, [selectedChannel]);

  // Send message
const sendMessage = async () => {
  const text = newMsg.trim();
  if (!text) return;

  await firebase.firestore().collection(selectedChannel).add({
    text,
    // ← use Firestore name, fall back to auth’s displayName
    sender: loggedInUser?.name || currentUser.displayName || 'Unknown',
    // ← use Firestore ppUrl, fall back to auth’s photoURL
    avatar: loggedInUser?.ppUrl  || currentUser.photoURL  || '',
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    ...(replyToMessage && {
      replyTo:      replyToMessage.id,
      replyToSender: replyToMessage.sender,
      replyToText:   replyToMessage.text,
    }),
  });

  setNewMsg('');
  setReplyToMessage(null);
};

  // Handle key events for Enter and mentions
  const handleKey = e => {
    if (e.key === 'Enter') sendMessage();
    const m = /@(\w*)$/.exec(e.target.value);
    if (m) {
      firebase.firestore().collection('users').orderBy('name')
        .startAt(m[1]).endAt(m[1] + '\uf8ff').limit(5)
        .get().then(s => setMentionResults(s.docs.map(d => d.data())));
      setShowMention(true);
    } else {
      if (e.target.value === '') setShowMention(false);
    }
  };

    const OpenModalButton = () => {
      const [open, setOpen] = React.useState(false);
    
      const handleOpen = () => setOpen(true);
      const handleClose = () => setOpen(false);
    
      return (
        <>
          <button onClick={handleOpen}>Housing Authority</button>
          <StateModal open={open} onClose={handleClose} />
        </>
      );
    };
  
  
    
    const OpenModalButton2 = () => {
      const [open, setOpen] = React.useState(false);
    
      const handleOpen = () => setOpen(true);
      const handleClose = () => setOpen(false);
    
      return (
        <>
          <button onClick={handleOpen}>Tenant Lookup</button>
          <TenantModal open={open} onClose={handleClose} />
        </>
      );
    };
function renderTextWithMentions(text, styles) {
  const parts = text.split(/((?:https?:\/\/|www\.)\S+|@[A-Za-z]+(?: [A-Za-z]+)*)/g);

  return parts.map((part, i) => {
    if (part.startsWith('@')) {
      return (
        <span key={i} style={styles.mention}>
          {part}
        </span>
      );
    } else if (/^(https?:\/\/|www\.)/.test(part)) {
      const url = part.startsWith('http') ? part : `https://${part}`;
      return (
        <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={styles.link}>
          {part}
        </a>
      );
    } else {
      return <span key={i}>{part}</span>;
    }
  });
}
  return (
    <div style={{ display: "flex", height: "100vh" ,     
}}>
      <Sidebar style={{ backgroundColor: '#000222 '}}>
      <Menu style={{ backgroundColor: '#000222'}}>
          <MenuItem >
          <div style={{marginLeft:-43, backgroundColor: 'white'}}>
          <img
            src="https://i.ibb.co/s2dBvDt/elevate.png"
            alt="logo"
            className="ml-4 mt-12 -p-4 "
            width={300}
          ></img>
          </div>
          </MenuItem>
          
          <MenuItem style={{ backgroundColor: '#000222', color:'white', marginTop:'50px'}} onClick ={()=> window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'propertylookup'}icon={<SearchIcon />}>Market Research</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

          <SubMenu label="Education" style={{ backgroundColor: '#000222', color:'white'}} icon={<SchoolIcon />}>
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}}  onClick ={()=> window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

            <MenuItem icon={<AccountBalanceRoundedIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://elevatecoachingrei.com/', "_blank")}>
              Coaching
            </MenuItem>
            <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
              1-on-1s
            </MenuItem>
            <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
              Day in the Office
            </MenuItem>
            <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
              Ride Along
            </MenuItem>

          </SubMenu>
          {/* <MenuItem icon={<GroupIcon />}>Tenant Finder</MenuItem> */}
          <SubMenu label="Tenant Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GroupIcon />}>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<HouseIcon />}> <OpenModalButton/> </MenuItem>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<EmojiPeopleIcon />}> <OpenModalButton2/> </MenuItem>
           
          </SubMenu>
          
            <MenuItem icon={<NoteAddIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Title Setup <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-15px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
            
            
           
                        <MenuItem icon={<GavelIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Legal Hub <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-10px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
                        <MenuItem icon={<CreditCard />} disabled style={{ backgroundColor: '#000222', color: 'white' }}> Credit Tradelines <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color: '#000222', width: 80, height: 10, fontSize: 8, marginLeft: '-73px', fontWeight: 600, marginTop: '-23px' }} /></MenuItem>

           
          <SubMenu label="Insurance Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GppGoodIcon />}>
            
            <MenuItem icon={<SupportIcon />} onClick ={()=> window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>
            <MenuItem disabled icon={<CottageIcon />}> Home Warrenties <Chip label={'Coming Soon!'} style={{ backgroundColor: '#000222', color:'white', width:80, height:10, fontSize:8,  marginLeft:'-95px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
            
          </SubMenu>
          <SubMenu label="Business Setup" style={{ backgroundColor: '#000222', color:'white'}} icon={<BusinessIcon />}>
            
            <MenuItem icon={<AddIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Form Entity </MenuItem>
            <MenuItem icon={<RequestQuoteIcon />}onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Taxes </MenuItem>
            <MenuItem icon={<CreditScoreIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Build Credit </MenuItem>
            <MenuItem icon={<LockIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Asset Protection </MenuItem>
            <MenuItem icon={<AttachMoneyIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Business Funding </MenuItem>
            
           
          </SubMenu>
          <SubMenu label="Elevate Financial" style={{ backgroundColor: '#000222', color:'white'}} icon={<PaidIcon />}>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} onClick ={()=> window.open('https://lendsimpli.com/elevate/', "_blank")}  icon={<CurrencyExchangeIcon />}   > Loan Portal </MenuItem>
            {/* <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<SpeedIcon />}> Credit Tradelines </MenuItem> */}
            
           
          </SubMenu>
          {/* <SubMenu label="Settings" style={{ backgroundColor: '#000222', color:'white'}} icon={<SettingsSuggestIcon />}>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<AccountCircleRoundedIcon />}> Account </MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<ShieldRoundedIcon />}> <OpenModalButton/> </MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<NotificationsRoundedIcon />}>
              Notifications
            </MenuItem>
          </SubMenu> */}
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect:true })}> Logout </MenuItem>
          <div style={{ ...styles.container, backgroundColor: '#000222',  }}>
          <ProfileComponent user={user } />

    </div>
        </Menu>
    </Sidebar>
    <div style={styles.container}>
      <aside style={styles.sidebar}>
        <h2 style={styles.sidebarHeader}>Community</h2>
        <ul style={styles.channelList}>
          {chatrooms.map(room => (
            <li key={room} style={{ ...styles.channelItem, ...(room === selectedChannel ? styles.activeChannel : {}) }} onClick={() => setSelectedChannel(room)}>
              <span style={styles.emoji}>{chatroomEmojis[room]}</span>
              <span style={styles.channelName}>#{room}</span>
              {unread[room] > 0 && <span style={styles.badge}>{unread[room]}</span>}
            </li>
          ))}
        </ul>
      </aside>

      <div style={styles.chatArea}>
        <header style={styles.chatHeader}><h3>#{selectedChannel}</h3></header>
        <div style={styles.messages}>
          {messages.map(msg => { const d = msg.createdAt?.toDate() || new Date(); const date = d.toLocaleDateString('en-US',{month:'2-digit',day:'2-digit',year:'2-digit'}); const time = d.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true}); return (
              <div key={msg.id} style={{ ...styles.messageItem, ...(hoveredMsg === msg.id ? styles.highlightedMessage : {}) }} onMouseEnter={() => setHoveredMsg(msg.id)} onMouseLeave={() => setHoveredMsg(null)}>
                <img src={msg.avatar} alt="avatar" style={styles.avatar} />
                <div>
                  {msg.replyToText && <div style={styles.replyInline}>Replying to {msg.replyToSender}: {msg.replyToText}</div>}
                  <div style={styles.meta}><span style={styles.sender}>{msg.sender}</span><span>{`${date}, ${time}`}</span></div>
<p style={styles.text}>
  {renderTextWithMentions(msg.text, styles)}
</p>                  {msg.reactions && Object.keys(msg.reactions).length > 0 && (
                    <div style={styles.reactionsContainer}>
                      {Object.entries(msg.reactions).map(([emoji, uids]) => (
                        <div key={emoji} style={styles.reaction}><span style={styles.reactionEmoji}>{emoji}</span><span style={styles.reactionCount}>{uids.length}</span></div>
                      ))}
                    </div>
                  )}
                </div>
                {hoveredMsg === msg.id && (
                  <div style={{ position: 'absolute', right: '8px', top: '8px', display: 'flex', gap: '4px' }}>
                    {reactionEmojis.map((emoji, idx) => (
                      <span key={idx} onClick={() => {
                        if (emoji === '↩️') {
                          setReplyToMessage(msg);
                        } else {
                          const ref = firebase.firestore().collection(selectedChannel).doc(msg.id);
                          firebase.firestore().runTransaction(tx => tx.get(ref).then(docSnap => {
                            const rec = docSnap.data().reactions || {};
                            const uids = rec[emoji] || [];
                            rec[emoji] = uids.includes(currentUser.uid) ? uids.filter(id => id !== currentUser.uid) : [...uids, currentUser.uid];
                            tx.update(ref, { reactions: rec });
                          }));
                        }
                      }} style={{ cursor: 'pointer' }}>{emoji}</span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          <div ref={messagesEndRef} />
        </div>

        {replyToMessage && (
          <div style={styles.replyPreview}>
            <span>Replying to {replyToMessage.sender}:</span>
            <button onClick={() => setReplyToMessage(null)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}>×</button>
          </div>
        )}

        <div style={styles.inputWrapper}>
          {showEmojiPicker && (
            <div style={styles.emojiPicker}>
              {reactionEmojis.map((e, i) => (
                <span key={i} onClick={() => { setNewMsg(prev => prev + e); inputRef.current.focus(); }}>{e}</span>
              ))}
            </div>
          )}
          {showMention && (
            <div style={styles.mentionList}>
              {suggestionList.map((u, i) => (
  <div
    key={i}
    style={styles.mentionItem}
    onClick={() => {
      setNewMsg(prev => prev.replace(/@\w*$/, '@' + u.name + ' '));
      setShowMention(false);
      inputRef.current.focus();
    }}
  >
    @{u.name}
  </div>
))}
            </div>
          )}
          <input ref={inputRef} style={styles.input} placeholder={`Message #${selectedChannel}`} value={newMsg} onChange={e => setNewMsg(e.target.value)} onKeyDown={handleKey} />
          <button style={styles.emojiButton} onClick={() => setShowEmojiPicker(v => !v)}>😀</button>
        </div>
      </div>
    </div>
    </div>
  );
}
